"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator = void 0;
const escodegen = require("escodegen");
/**
 * This will generate code from the AST
 * @param ast
 */
const generator = (ast, options) => {
    let code = ast.body.map((expr) => escodegen.generate(expr)).join('\n');
    return code;
};
exports.generator = generator;
